import type { ReactNode } from 'react';

import { cn } from '~/utils/cn';

/**
 * Outer wrapper for every Content page: one max width and vertical rhythm, so pages line
 * up when you move between them. The padding, card and page background (`bg-gradient-page`)
 * are owned by `ContentLayout`, which renders the page inside its tabbed panel.
 */
export function ContentPage({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'motion-safe:animate-in motion-safe:fade-in-0 motion-safe:slide-in-from-bottom-1 mx-auto flex w-full max-w-[1680px] flex-col gap-8 duration-300',
        className,
      )}
    >
      {children}
    </div>
  );
}
